/**
 * ⚠️ IMPORTANT:
 * This comparator (`compareNumericFirst`) is also used in the `pos-order-fullfilment` repo for
 * identical menu sorting.
 */
const compareNumericFirst = (sortDirection = 'asc') => {
  return (a, b) => {
    const nameA = a.trim();
    const nameB = b.trim();

    const isNumberOnlyA = /^\d+$/.test(nameA);
    const isNumberOnlyB = /^\d+$/.test(nameB);

    // asc: put numeric-only names at the top
    // desc: put numeric-only names at the bottom
    if (isNumberOnlyA && !isNumberOnlyB) return sortDirection === 'asc' ? -1 : 1;
    if (!isNumberOnlyA && isNumberOnlyB) return sortDirection === 'asc' ? 1 : -1;

    // otherwise do natural, case-insensitive sorting
    const result = nameA.localeCompare(nameB, undefined, {
      numeric: true,
      sensitivity: 'base',
    });
    return sortDirection === 'asc' ? result : -result;
  };
};

const state = () => ({
  items: null,
});

const actions = {
  update({ commit }, menuProducts) {
    commit("UPDATE", menuProducts);
  },
};

const getters = {
  bySection({ items, sortDirection = 'asc' }) {
    if (!items) {
      return Object.create(null);
    }

    let groupedItems = items.reduce((r, a) => {
      r[a.section] = r[a.section] || [];
      r[a.section].push(a);

      if (a.pricebook_info.promotions.length) {
        r['Specials'] = r['Specials'] || [];
        if (!r['Specials'].some(s => s.upc === a.upc)) {
          r['Specials'].push(a);
        }
      }
      return r;
    }, Object.create(null));

    const sortedSections = Object.keys(groupedItems).sort(compareNumericFirst(sortDirection));

    const sortedGroupedItems = Object.create(null);
    sortedSections.forEach(section => {
      sortedGroupedItems[section] = groupedItems[section];
    });

    return sortedGroupedItems;
  }
};

const mutations = {
  UPDATE(state, payload) {
    state.items = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
